/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import { LottieLoaderV } from "../widgets/LottieLoaderV";
import { TRACK_LOADER_LOTTIE } from "../assets/images";

const { isAuthenticated } = {};

const LandingPage = lazy(() => import("../pages/Landing"));
const ProductViewPage = lazy(() => import("../pages/ProductView"));
const ProductDetailViewPage = lazy(() => import("../pages/ProductDetailView"));
const ProvenanceStepDetailPage = lazy(
    () => import("../pages/ProvenanceStepDetailView")
);
const MainViewPage = lazy(() => import("../pages/MainPage"));
const ProvenanceViewPage = lazy(() => import("../pages/ProvenancePage"));
const TermsPage = lazy(() => import("../pages/TermsandCondition"));
const PrivacyPage = lazy(() => import("../pages/PrivacyPolicy"));
const TrinetraScannerPage = lazy(() => import("../pages/TrinetraScanner"));
const TrinetraPreviewPage = lazy(() => import("../pages/TrinetraPreview"));
const ThreeDPage = lazy(()=>import("../pages/ThreeDView"));
const ThreePage = lazy(()=>import("../pages/StaticThreeD"));
const LandingPrimePage = lazy(() => import("../pages/LandingPrime"));

const StepDetailPage = lazy(() => import("../pages/StepDetailPage"));
const ThreeDDescriptionPage = lazy(() => import("../pages/ThreeDDescription"));

const RouterConfig = (props) => (
    <Switch>
        <Route path="/our-commitment-to-nature" component={ThreeDDescriptionPage} />
        <Route path="/product-provenance" component={StepDetailPage} />
        <Route path="/product-detail" component={ProductDetailViewPage} />
        <Route path="/product" component={MainViewPage} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route path="/trinetraScanner" component={TrinetraScannerPage} />
        <Route path="/trinetraPreview" component={TrinetraPreviewPage} />
        <Route path="/three-d-view" component={ThreeDPage} />
        <Route path="/" component={LandingPage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/login`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<LottieLoaderV src={TRACK_LOADER_LOTTIE} lottieBgColor={"#234f1e"} loadingText={" "}/>}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
